import { render } from "./VuesaxLinearPath.vue?vue&type=template&id=12b3d52b"
import script from "./VuesaxLinearPath.vue?vue&type=script&lang=js"
export * from "./VuesaxLinearPath.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__